'use client'
import { jsx } from "react/jsx-runtime";
import { createContext } from "react";
const DayMapContext = /*#__PURE__*/ createContext(null);
function DayMapProvider({ children, dayMap = {
    variant: 'day'
}, mode = 'single' }) {
    const context = {
        dayMap,
        mode
    };
    return /*#__PURE__*/ jsx(DayMapContext.Provider, {
        value: context,
        children: children
    });
}
export { DayMapContext, DayMapProvider };
